export default
function (ngModule) {
    ngModule.directive('instagramDocumentCard', [function(){
        return {
            restrict: 'E',
            template: require('./mw-card.html'),
            controllerAs: 'vm',
            controller: 'InstagramDocumentCardController',
            scope: {
                document: '=?',
                displaySettings: '=',
                documentClick: '&',
                overlaySentiment: '&',
                isNarrowCard: '=',
                showFooter: '=',
                showOpenDocumentIcon: '=',
                minimumImageSize: '='
            }
        };
    }])
    .controller('InstagramDocumentCardController', [
        '$scope',
        'UriService',
        'GeoService',
        'translationService',
        InstagramDocumentCardController
    ]);

    function InstagramDocumentCardController($scope, UriService, GeoService, TranslationService){

        // this stuff should probably live in the card directive
        this.mediaAvailable = false;

        this.onMediaAvailable = function onMediaAvailable() {
            this.mediaAvailable = true;
        }.bind(this);

        this.imageAvailableOptions = {
            onMediaAvailable: this.onMediaAvailable,
            minimumImageSize: $scope.minimumImageSize
        };

        var documentClick = function documentClick(url, event) {
            if(url) {
                return $scope.documentClick({
                    event: event,
                    document: $scope.document,
                    url: url
                });
            }
        };

        var update = function update() {

            var media = $scope.document.images.reduce(function(previous, current) {
                previous[current.name] = UriService(current.link).addSearch('cb', new Date().setHours(0,0,0,0)).toString();
                return previous;
            }, {});

            var author = ($scope
                && $scope.document
                && $scope.document.authors
                && $scope.document.authors[0])
                || {};

            this.document = $scope.document;
            this.imagesVisible = $scope.displaySettings.images;
            this.avatarsVisible = $scope.displaySettings.avatar;
            this.isNarrowCard = $scope.isNarrowCard;
            this.showFooter = $scope.showFooter;
            this.showOpenDocumentIcon = $scope.showOpenDocumentIcon;
            this.mediaType =  $scope.document.mediaType;
            this.mediaTypeIcon = $scope.document.mediaTypeIcon || $scope.document.mediaType;
            this.avatarTitle =  author.name || author.handle;

            this.avatarImageUrl =  author.avatarUrl;

            this.avatarLinkUrl =  author.url;
            this.documentUrl =  $scope.document.redirectUrl || $scope.document.url;
            this.sourceUrl =  author.url;
            this.sourceName =  author.name;

            this.authors = [{
                name: author.handle || TranslationService.getLocalizedString('Unknown'),
                url: author.url,
                onClick: documentClick.bind(this, author.url)
            }];

            GeoService.convertCountryCodeToCode3($scope.document.country).then(function updateModelCountryCode (code) {
                this.countryCode = code;
            }.bind(this));

            this.date =  $scope.document.date;

            this.bigText = $scope.displaySettings.hitSentence
                ? [($scope.document.matchSentence || $scope.document.tagContextMatchSentence || $scope.document.body)]
                : [];

            this.image = $scope.displaySettings.images && media['image/instagram/low'];
            this.tags = ($scope.displaySettings.displayTags && $scope.document.tags) || [];
            this.keywords = ($scope.displaySettings.keywords && ($scope.document.keywords || $scope.document.tagContextKeywords)) || [];
            this.socialReach =  $scope.document.reach;
            this.sentiment =  $scope.document.sentiment;
            this.documentId =  $scope.document.documentId;
            this.isSentimentModified = $scope.document.isSentimentModified;
            this.originalSentiment = $scope.document.originalSentiment;

            this.onAvatarClick = documentClick.bind(this, this.avatarLinkUrl);
            this.onSourceIconClick = documentClick.bind(this, this.documentUrl);
            this.onSourceNameClick = documentClick.bind(this, this.sourceUrl);
            this.onDocumentOpenClick = documentClick.bind(this, this.documentUrl);
            this.onContentImageClick = documentClick.bind(this, this.documentUrl);

            this.onOverlaySentimentClick = $scope.overlaySentiment;

        }.bind(this);

        $scope.$watch('displaySettings', update, true);
        $scope.$watch('document', update, true);

        update();

    }

}



// WEBPACK FOOTER //
// ./source/components/document-card/instagram-document-card.js